'use strict';

module.exports = {
	name: 'Binary-Question',

	template: '#question-template',

	props: [
		'question',
		'order'
	],

	data: function () {
		return {
			answer: null
		}
	},

	computed: {
		eligibleResponse() {
			if (this.question.eligible_response === 'a') {
				return true
			}
			return false
		},

		eligible() {
			if (this.answer != null) {
				return this.answer
			}
			return true
		}
	},

	watch: {
		answer: function() {
			this.$emit('answered', { eligible: this.answer, order: this.order})
		}
	}
};
